<div class="white-wrapper layout-fluid-constrained layout-align-center">
  <h1 class="page-name">Забравена парола</h1>
  <form [formGroup]="forgottenPasswordForm" class="form-horizontal login-box-form">
    <app-form-element name="email" label="Въведете вашият E-mail, за да получите нова парола" type="INPUT" placeholder="{{'E-mail адрес'}}" helperText="{{'Моля въведете E-mail адресът, с който сте регистриран. Ако сте го забравили, моля обадете ни се на 0700 100 76.'}}"></app-form-element>
  </form>
  <button class="btn btn-orange" (click)="regeneratePassword()">Изпрати</button>
</div>
